import React, { useState, useEffect } from 'react';

import { SingleInput, SingleText, SingleSelect } from '../../Res/BaseInput';
import { RespCustomerPositionInfo_WageInfo_WageType1, BusinessTaxType_Arr, InsuranceBurdenType_Arr } from '../../../../item/ItemCustomerPosition';
import { getItemsInfo } from '../../../../item/ItemTools';
import { AddButton, DeleteButton, Space } from '../../Res/BaseButton';
import { ItemPayHourlyWage } from './ItemPayHourlyWage';

export function ItemWageTypeInfo1({ item, action, isEdit = true }) {
  const [wageTypeInfo, setWageTypeInfo] = useState({})
  const [InvoiceHourlyWage1, setInvoiceHourlyWage1] = useState("")
  const [InvoiceHourlyWage2, setInvoiceHourlyWage2] = useState("")
  const [InvoiceHourlyWage3, setInvoiceHourlyWage3] = useState("")
  const [InvoiceHourlyWage4, setInvoiceHourlyWage4] = useState("")
  const [BusinessTaxType, setBusinessTaxType] = useState("")
  const [InsuranceBurdenType, setInsuranceBurdenType] = useState("")
  const [PayHourlyWage1, setPayHourlyWage1] = useState("")
  const [PayHourlyWage2, setPayHourlyWage2] = useState("")
  const [PayHourlyWage3, setPayHourlyWage3] = useState("")
  const [PayHourlyWage4, setPayHourlyWage4] = useState("")
  const [ExtraPayeHourlyWage, setExtraPayeHourlyWage] = useState("")
  const [AddInsuranceBurdenType, setAddInsuranceBurdenType] = useState("")
  const [SalaryAddItem, setSalaryAddItem] = useState([])
  const [SalarySubtractItem, setSalarySubtractItem] = useState([])

  const Wage1_Title = "正常班時薪-前8小時"
  const Wage2_Title = "加班時薪-前2小時-1.34"
  const Wage3_Title = "超時加班時薪-2小時後-1.67"
  const Wage4_Title = "假日加班時薪-2"
  const BusinessTaxType_Title = "營業稅"
  const ExtraPayeHourlyWage_Tilel = "家庭照顧金"
  const InsuranceBurdenType_Tilel = "勞健保保險費用"
  const AddInsuranceBurdenType_Tilel = "健保補充保費"

  useEffect(() => {
    console.log(item)
    if (item !== undefined && wageTypeInfo !== item) {
      setWageTypeInfo(item)
      setInvoiceHourlyWage1(item.InvoiceHourlyWage1)
      setInvoiceHourlyWage2(item.InvoiceHourlyWage2)
      setInvoiceHourlyWage3(item.InvoiceHourlyWage3)
      setInvoiceHourlyWage4(item.InvoiceHourlyWage4)
      setBusinessTaxType(item.BusinessTaxType)
      setPayHourlyWage1(item.PayHourlyWage1)
      setPayHourlyWage2(item.PayHourlyWage2)
      setPayHourlyWage3(item.PayHourlyWage3)
      setPayHourlyWage4(item.PayHourlyWage4)
      setExtraPayeHourlyWage(item.ExtraPayeHourlyWage)
      setSalaryAddItem(item.SalaryAddItem)
      setSalarySubtractItem(item.SalarySubtractItem)
    }
  }, [item])

  useEffect(() => {
    if (action !== undefined) {
      var mWageTypeInfo = new RespCustomerPositionInfo_WageInfo_WageType1({
        InvoiceHourlyWage1,
        InvoiceHourlyWage2,
        InvoiceHourlyWage3,
        InvoiceHourlyWage4,
        BusinessTaxType,
        InsuranceBurdenType,
        PayHourlyWage1,
        PayHourlyWage2,
        PayHourlyWage3,
        PayHourlyWage4,
        ExtraPayeHourlyWage,
        AddInsuranceBurdenType,
        SalaryAddItem,
        SalarySubtractItem
      })
      console.log(mWageTypeInfo)
      action(mWageTypeInfo)
    }
  }, [InvoiceHourlyWage1, InvoiceHourlyWage2, InvoiceHourlyWage3, InvoiceHourlyWage4, BusinessTaxType, InsuranceBurdenType
    ,PayHourlyWage1, PayHourlyWage2, PayHourlyWage3, PayHourlyWage4, ExtraPayeHourlyWage, AddInsuranceBurdenType,  SalaryAddItem, SalarySubtractItem, action])

  return (
    <>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>時薪計算條件</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>請款金額</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleInput title={Wage1_Title}
                val={InvoiceHourlyWage1}
                action={setInvoiceHourlyWage1}
                type={"number"}
                placeholder={"130"}
                size={2}
              />
              :
              <SingleText title={Wage1_Title} val={InvoiceHourlyWage1} size={2} />
          }
          {
            isEdit ?
              <SingleInput title={Wage2_Title}
                val={InvoiceHourlyWage2}
                action={setInvoiceHourlyWage2}
                type={"number"}
                size={2}
              />
              :
              <SingleText title={Wage2_Title} val={InvoiceHourlyWage2} size={2} />
          }
          {
            isEdit ?
              <SingleInput title={Wage3_Title}
                val={InvoiceHourlyWage3}
                action={setInvoiceHourlyWage3}
                type={"number"}
                size={2}
              />
              :
              <SingleText title={Wage3_Title} val={InvoiceHourlyWage3} size={2} />
          }
          {
            isEdit ?
              <SingleInput title={Wage4_Title}
                val={InvoiceHourlyWage4}
                action={setInvoiceHourlyWage4}
                type={"number"}
                size={2}
              />
              :
              <SingleText title={Wage4_Title} val={InvoiceHourlyWage4} size={2} />
          }

          {isEdit ?
            <SingleSelect title={BusinessTaxType_Title}
              val={BusinessTaxType}
              attr={BusinessTaxType_Arr}
              action={setBusinessTaxType}
              hasBlank={true}
              blankVal={"0"}
              size={2}
            />
            : <SingleText
              title={BusinessTaxType_Title}
              val={getItemsInfo({
                items: BusinessTaxType_Arr,
                val: BusinessTaxType
              })}
              size={2} />
          }
          {
            isEdit ?
            <SingleSelect title={InsuranceBurdenType_Tilel}
              val={InsuranceBurdenType}
              attr={InsuranceBurdenType_Arr}
              action={setInsuranceBurdenType}
              hasBlank={false}
              size={2}
            />
            : <SingleText
              title={InsuranceBurdenType_Tilel}
              val={getItemsInfo({
                items: InsuranceBurdenType_Arr,
                val: InsuranceBurdenType
              })}
              size={2} />
          }
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>給付金額</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleInput title={Wage1_Title}
                val={PayHourlyWage1}
                action={setPayHourlyWage1}
                type={"number"}
                placeholder={"130"}
                size={2}
              />
              :
              <SingleText title={Wage1_Title} val={PayHourlyWage1} size={2} />
          }
          {
            isEdit ?
              <SingleInput title={Wage2_Title}
                val={PayHourlyWage2}
                action={setPayHourlyWage2}
                type={"number"}
                size={2}
              />
              :
              <SingleText title={Wage2_Title} val={PayHourlyWage2} size={2} />
          }
          {
            isEdit ?
              <SingleInput title={Wage3_Title}
                val={PayHourlyWage3}
                action={setPayHourlyWage3}
                type={"number"}
                size={2}
              />
              :
              <SingleText title={Wage3_Title} val={PayHourlyWage3} size={2} />
          }
          {
            isEdit ?
              <SingleInput title={Wage4_Title}
                val={PayHourlyWage4}
                action={setPayHourlyWage4}
                type={"number"}
                size={2}
              />
              :
              <SingleText title={Wage4_Title} val={PayHourlyWage4} size={2} />
          }

          {isEdit ?
              <SingleInput title={ExtraPayeHourlyWage_Tilel}
                val={ExtraPayeHourlyWage}
                action={setExtraPayeHourlyWage}
                type={"number"}
                size={2}
              />
              :
              <SingleText title={ExtraPayeHourlyWage_Tilel} val={ExtraPayeHourlyWage} size={2} />
          }
          {
            isEdit ?
            <SingleSelect title={AddInsuranceBurdenType_Tilel}
              val={AddInsuranceBurdenType}
              attr={InsuranceBurdenType_Arr}
              action={setAddInsuranceBurdenType}
              hasBlank={false}
              size={2}
            />
            : <SingleText
              title={AddInsuranceBurdenType_Tilel}
              val={getItemsInfo({
                items: InsuranceBurdenType_Arr,
                val: AddInsuranceBurdenType
              })}
              size={2} />
          }
        </div>
      </div>
      <Space />
      <Space />
      <div className="row">
        <div className="col-md-12">
          <div className="col-lg-6">
            <ItemPayHourlyWage title={"薪資加項"} items={SalaryAddItem} action={setSalaryAddItem} isEdit={isEdit} />
          </div>
          <div className="col-lg-6">
            <ItemPayHourlyWage title={"薪資減項"} items={SalarySubtractItem} action={setSalarySubtractItem} isEdit={isEdit} />
          </div>
        </div>
      </div>
    </>
  )
}